import React from 'react';
import isObject from "lodash/isObject";
export default function defaultRender(value, className) {
  if (className === void 0) {
    className = '';
  }
  if (value === undefined || value === null) {
    return '';
  }
  if (isObject(value)) {
    value = JSON.stringify(value);
  }
  return /*#__PURE__*/React.createElement("span", {
    title: value,
    className: className
  }, value);
}
;